import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useMousePosition } from '../hooks/useMousePosition';
import { ProjectsListItem } from '../data/projectsList';
import { ProjectsItemStyles } from '../styles/styles';
import { Animations } from '../utils/animations';

type Prop = {
  data: ProjectsListItem;
};

const ProjectsItem = (props: Prop) => {
  const {
    title,
    src,
    leftFlex,
    rightFlex,
    thumbnailOffset,
    offsetX,
    offsetY,
    id,
  } = props.data;
  const { x, y } = useMousePosition();
  const [listPosition, setListPosition] = useState({ top: 0, left: 0 });
  const [hovered, setHovered] = useState(false);
  const listRef = useRef<HTMLLIElement>(null);
  const { transition, maskAnimation, textReveal } = Animations();

  useEffect(() => {
    if (listRef.current) {
      setListPosition({
        top: listRef.current.getBoundingClientRect().top,
        left: listRef.current.getBoundingClientRect().left,
      });
    }
  }, [hovered]);

  return (
    <ProjectsItemStyles
      ref={listRef}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}>
      <Link to={`/projects/${id}`}>
        <div className="wrapper">
          <div className={`line left flex-${leftFlex}`}>
            <motion.div
              variants={maskAnimation}
              transition={{ ...transition, duration: 1 }}
              className="mask"></motion.div>
            <motion.div
              initial={{ backgroundColor: '#0f0e0e' }}
              animate={{ backgroundColor: 'unset' }}
              className="cover"></motion.div>
          </div>
          <motion.div className="title tap-highlight-transparent">
            <h2>
              <motion.div
                variants={textReveal}
                transition={transition}
                className="text tap-highlight-transparent">
                {title}
              </motion.div>
            </h2>
          </motion.div>
          <motion.div className="thumbnail" style={{ left: thumbnailOffset }}>
            <img src={src} alt="" />
            <motion.div
              variants={maskAnimation}
              transition={{ ...transition, duration: 1 }}
              className="mask"></motion.div>
            <motion.div
              initial={{ backgroundColor: '#0f0e0e' }}
              animate={{ backgroundColor: 'unset' }}
              className="cover"></motion.div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: hovered ? 1 : 0,
              x: `calc(${x - listPosition.left}px - ${offsetX}vw)`,
              y: `calc(${y - listPosition.top}px - ${offsetY}vw)`,
            }}
            transition={{ ease: 'linear', duration: 0.2 }}
            className="floating-image">
            <motion.img
              animate={{
                x: hovered ? 0 : '-120%',
                opacity: hovered ? 1 : 0.7,
              }}
              transition={{
                ease: [0.6, -0.05, 0.01, 0.9],
                duration: 0.6,
                delay: 0.05,
              }}
              src={src}
              alt=""
            />
          </motion.div>
          <motion.div
            variants={maskAnimation}
            transition={{ ...transition, duration: 1 }}
            className={`line right flex-${rightFlex}`}>
            <motion.div
              variants={maskAnimation}
              transition={{ ...transition, duration: 1 }}
              className="mask right"></motion.div>
            <motion.div
              initial={{ backgroundColor: '#0f0e0e' }}
              animate={{ backgroundColor: 'unset' }}
              className="cover"></motion.div>
          </motion.div>
        </div>
      </Link>
    </ProjectsItemStyles>
  );
};

export default ProjectsItem;
